import React, { Component } from 'react';
import CardSimple from 'screens/components/basic/CardSimple';

const Admin = () => {
    return(
        <div id="admin-cash-register">
            <br />
            <div>
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>Cash Register</h2>
                        <p>TechPOS allows you to monitor the sales per employee and per workstation under the Admin Section. You can
                        view any open, cancelled, or finished orders per shift, the cash in and cash out of the employee, and monitor the
                        payments for the current branch.</p>
                        <p>To get to the Cash Register</p>
                        <ul>
                            <li>Go to Menu > Admin > Cash Register</li>
                            <img src={require("./SupportDocImages/admin_images/admin1.PNG")} />
                        <br />
                        <img src={require("./SupportDocImages/admin_images/admin2.PNG")} width="900px" />
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="admin-view-orders">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to View an Order</h2>
                        <ul>
                            <li>Go to Menu > Admin > Cash Register</li>
                            <img src={require("./SupportDocImages/admin_images/admin1.PNG")} />
                            <li>Select the shift you would like to see the orders from. Click the Eye button</li>
                            <li>Scroll down to see the Orders</li>
                            <img src="http://techpos.ca/support-images/Admin/ViewOrder/ViewOrder-3.png" />
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="admin-cancel-order">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to Cancel and Order</h2>
                        <ul>
                            <li>Go to Menu > Admin > Cash Register</li>
                            <img src={require("./SupportDocImages/admin_images/admin1.PNG")} />
                            <li>Select the shift with the open order</li>
                            <li>Scroll down to see the Opened Order List and click the Cancel button on the desired Order</li>
                            <img src="http://techpos.ca/support-images/Admin/CancelOrder/CancelOrder-3.png" />
                        </ul>
                        {/* NEED TO FIGURE OUT IF THIS IS STILL VIABLE */}
                        {/* <p><b>NOTE: Alternatively you can go to the toolbox and click Opened Orders</b></p>
                        <ul>
                            <img src="http://techpos.ca/support-images/admin/admin8.PNG" />
                            <li>Click on Cancel Order</li>
                            <img src="http://techpos.ca/support-images/admin/admin9.PNG" />
                            <li>Write a comment or note for canceling the order. Click on Confirm</li>
                            <img src="http://techpos.ca/support-images/admin/admin10.PNG" />
                        </ul> */}
                    </div>
                </CardSimple>
            </div>
            <div id="admin-register-status">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>Register Status</h2>
                        <p>In the table you can see that every shift has a different status.</p>
                        <p>A register with an <strong>Opened</strong> status means that there is an active shift on that register</p>
                        <p>A register with a <strong>Closing in Progress</strong> status means that the shift is closed but the cash out is not
                        done.</p>
                        <p>A register with a <strong>Closed</strong> status means that the shift is closed and that the cash out was performed. Once a
                        shift is closed, no further changes are allowed.</p>
                        <p>A register with a <strong>Diverged</strong> status means that the cash out was done but there is an investigation to be
                        performed on that shift.</p>
                    </div>
                </CardSimple>
            </div>
            <div id="admin-close-register">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to Close a Register</h2>
                        <ul>
                            <li>Go to Menu > Admin > Cash Register</li>
                            <img src={require("./SupportDocImages/admin_images/admin1.PNG")} />
                            <li>On the table select the shifts you want to close</li>
                            <img src="http://techpos.ca/support-images/Admin/CloseRegister/CloseRegister-2.png" />                            
                            <li>Click the Close button at the top of the screen and you will be prompted with a confirmation message</li>
                            <img src="http://techpos.ca/support-images/Admin/CloseRegister/CloseRegister-3.png" />
                        </ul>
                        <p><b>NOTE: This will change the status from Opened to Closing in Progress</b></p>
                    </div>
                </CardSimple>
            </div>
            <div id="admin-cash-out">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to Cash Out</h2>
                        <ul>
                            <li>After closing the register (refer section How to Close a Register?) or after the employee has closed the
                            register on his own, Locate in the table the shift to Cash Out.</li>
                            <li>Click VIEW to enter the Register details.</li>
                            <img src="http://techpos.ca/support-images/Admin/CashOut/CashOut-1.png" />
                            <li>Count the cash the employee is returning and type the amount on Actual Cash Out Amount. If the
                            amount is exact, under "Verified expected and actual are equal" the red square will change to Correct. If it is
                            different within a range of 10 dollars, the red square will change to Correct with a tolerance of 10 dollars.
                            If it is out of the range of the 10 dollars, the square will remain Divergent.</li>
                            <img src="http://techpos.ca/support-images/Admin/CashOut/CashOut-2.png" width="800"/>
                            <li>Add notes (if applicable). Click on Not Verified (If further investigation is needed) or Verify to terminate
                            the Cash Out. NOTE: Pressing Not Verified will change the status of the shift to Diverged. Pressing Verify will
                            change the status to Closed</li>
                            <img src="http://techpos.ca/support-images/Admin/CashOut/CashOut-3.png" />
                        </ul>
                    </div>
                </CardSimple>
            </div>
        </div>
    )
}

export default Admin;